'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled version of the Fragment component
 * @private
 * @type {StyledComponent}
 * @reactProps {Object} props
 *   The properties
 * @reactProps {(ReactNode|ReactNode[])} children
 * @reactProps {?Boolean} active
 * @reactProps {?string} animation
 */
var StyledFragment = _styledComponents2.default.span.withConfig({
  displayName: 'fragment__StyledFragment'
})(['--direction:1;', ';display:', ';', ';', ';'], function (_ref) {
  var mixin = _ref.mixin;
  return mixin || '';
}, function (_ref2) {
  var displayAs = _ref2.displayAs;
  return displayAs || 'inline-block';
}, function (_ref3) {
  var isFit = _ref3.isFit;
  return isFit ? '\n    display: flex;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n  ' : '';
}, function (props) {
  return props.animation || '\n      visibility: ' + (props.isActive ? 'visible' : 'hidden') + '\n  ';
});

/**
 * @private
 * @type {String}
 */
StyledFragment.displayName = 'StyledFragment';

/**
 * @private
 * @type {Object}
 * @prop {(ReactNode|ReactNode[])} children
 * @prop {?Boolean} isActive
 * @prop {?(String|Array)} animation
 */
StyledFragment.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  isFit: _propTypes2.default.bool,
  isActive: _propTypes2.default.bool,
  mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
  animation: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string])
};

exports.default = StyledFragment;